export const BOOKING_GUIDE_EVENT = 'portfolio:book-guide'

export function requestBookingGuide() {
  window.dispatchEvent(new CustomEvent(BOOKING_GUIDE_EVENT))
}
